import { AlertCircle } from 'lucide-react';
import { cn } from '@/utils/cn';

interface ErrorAlertProps {
  message: string | null | undefined;
  className?: string;
}

/**
 * Inline error message. Uses design-system danger tokens and type scale.
 */
export function ErrorAlert({ message, className }: ErrorAlertProps) {
  if (!message) return null;

  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-md border border-danger-200 bg-danger-50 p-3',
        'text-small text-danger-700',
        className,
      )}
    >
      <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>{message}</span>
    </div>
  );
}
